import ProjectsDrawing from './ProjectsDrawing';

export default ProjectsDrawing;
